// Local development configurations
// export const API_URL = 'http://localhost:8080/api/chat';
// export const WEBSOCKET_URL = 'ws://localhost:8080/api/v1/chat-stream-relay';

// Development configuration
export const API_URL = 'https://chat-dev.otter.com.co/api/chat';
export const WEBSOCKET_URL = 'wss://chat-dev.otter.com.co/api/v1/chat-stream-relay';

// Production configuration
// export const API_URL = 'https://chat-prod.otter.com.co/api/chat';
// export const WEBSOCKET_URL = 'wss://chat-prod.otter.com.co/api/v1/chat-stream-relay';

// India Production configurations
// export const API_URL = 'https://chat-ind-prod.otter.com.co/api/chat';
// export const WEBSOCKET_URL = 'wss://chat-ind-prod.otter.com.co/api/v1/chat-stream-relay';

// Always use this for user-chat window in both productions if needed
export const MAIN_PROD_WEBSOCKET_URL = 'wss://chat-prod.otter.com.co/api/v1/chat-stream-relay';

// Environment configuration (based on the current API_URL)
export const ENVIRONMENT = API_URL.toLowerCase().includes('localhost') ? 'local'
     : API_URL.toLowerCase().includes('chat-dev') ? 'development'
          : 'production';

export const ALLOW_DEVTOOLS = ENVIRONMENT === 'local' || ENVIRONMENT === 'development';

// API Keys and URL
export const OPENAI_API_KEY = '';
export const ANTHROPIC_API_KEY = '';
export const CEREBRAS_API_KEY = 'csk-f45n6r8y8fc4m6hft85xcxh683hpp5p8rdhr53cc5ycd2xcf';
export const DEEPGRAM_URL = 'wss://api.deepgram.com/v1/listen?model=nova-2&punctuate=true&interim_results=true&no_audio_timeout=200';
export const AES_SECRET_KEY= 'jzp7LJ1OH2pbjH0un6A7bE2OL5oLXI1+H0qbLF2OP3o='

// GCP Vertex AI Configuration for Anthropic Claude
export const GCP_PROJECT_ID = 'gen-lang-client-0668161308';
// IMPORTANT: Vertex AI access tokens are short-lived (~1 hour). Never hardcode them in the frontend.
// Leave empty and let the app fetch fresh tokens from the backend endpoint(s) below.
export const GCP_ACCESS_TOKEN = '';
// Token endpoint on our backend (VertexAiController @RequestMapping "/api/chat/vertex-ai")
export const GCP_ACCESS_TOKEN_ENDPOINT = `${API_URL}/vertex-ai/access-token`;

// Vertex AI Claude regions with quotas
export const VERTEX_AI_REGIONS = ['asia-southeast1', 'us-east5', 'global'] as const;
export type VertexAIRegion = typeof VERTEX_AI_REGIONS[number];

// Vertex AI Claude model mapping
export const VERTEX_AI_CLAUDE_MODELS = {
  'anthropic-claude-sonnet-4-5': 'claude-sonnet-4-5@20250929',
  'anthropic-claude-sonnet-4-6': 'claude-sonnet-4-6',
  'anthropic-claude-opus-4-6': 'claude-opus-4-6',
  'anthropic-claude-opus-4-1': 'claude-opus-4-1@20250805',
  'claude-opus-4-6': 'claude-opus-4-6',
  'claude-opus-4-1@20250805': 'claude-opus-4-1@20250805',
} as const;
export type VertexAIClaudeModel = keyof typeof VERTEX_AI_CLAUDE_MODELS;

export const emails = {
     "Jagadish": 'p_jagadish@sbcgroup-india.com',
     "Sarath": 'k_sarath@sbcgroup-india.com',
     "veeraju": 'veeraju.medha@sbcgroup-india.com'
}
